import { createAction } from 'redux-actions';
import { GET_PROCESOS_COD } from '../constants'
import { apiGetProcesosCod } from '../api'
import { getProcesosCodUrl } from '../api/urls'

export const getProcesosCod = createAction(GET_PROCESOS_COD,
    (datos) => apiGetProcesosCod(getProcesosCodUrl + datos)());
